import type { UiState } from 'instantsearch.js';

import { useInstantSearchIndexName } from 'src/app/pages/search/shared/hooks';

import { routeToState, stateToRoute } from '../../config';

type Result = ModelHookResult<
	undefined,
	{
		stateToRoute: (uiState: UiState) => UiState;
		routeToState: (routeState: UiState) => UiState;
	}
>;

export function useStateMapping(): Result {
	const {
		data: { instantSearchIndexName },
	} = useInstantSearchIndexName();

	return {
		actions: {
			stateToRoute: (uiState: UiState) => {
				return stateToRoute(uiState, instantSearchIndexName) as UiState;
			},
			routeToState: (routeState: UiState) => {
				return routeToState(routeState, instantSearchIndexName);
			},
		},
	};
}
